import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import OrgApi from "../api/organization";
import AuthorCard from "../author-card/author-card.vue";
import { Popover } from "@h3/antd-vue";
import getDownloadUrlNew from '../../../utils/getDownloadUrlNew';
let AuthorAvatarInfo = class AuthorAvatarInfo extends Vue {
    constructor() {
        super(...arguments);
        //   @Prop()sourceId?:string;
        //   @Prop()imgUrl!:any;
        //   @Prop()sourceName!:string;
        this.cardData = {}; //卡片数据
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    returnClick(event) {
        return;
    }
    /**
     * 获取数据
     */
    authorChange(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log(id);
            this.cardData = {};
            const res = yield OrgApi.getOrgUserInfo({ id: id });
            if (res.errcode === 0) {
                this.cardData = res.data;
            }
        });
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
};
tslib_1.__decorate([
    Prop({ default: {
            sourceId: '',
            imgUrl: '',
            sourceName: '',
            onlyImg: false
        } })
], AuthorAvatarInfo.prototype, "item", void 0);
AuthorAvatarInfo = tslib_1.__decorate([
    Component({
        name: "author-avatar-info",
        components: {
            AuthorCard,
            APopover: Popover,
        },
    })
], AuthorAvatarInfo);
export default AuthorAvatarInfo;
